import { NavItemType } from './candidateProfile.type';

export const tab = {
  basic: 'basic',
  skill: 'skill',
  education: 'education',
  experience: 'experience',
  role: 'role',
  availability: 'availability',
  resume: 'resume'
};

export const navItems: NavItemType[] = [
  {
    label: 'Basic',
    eventKey: tab.basic,
    icon: 'user'
  },
  {
    label: 'Skill',
    icon: 'award',
    eventKey: tab.skill
  },
  {
    label: 'Education',
    eventKey: tab.education,
    icon: 'book'
  },
  {
    label: 'Experience',
    icon: 'settings',
    eventKey: tab.experience
  },
  {
    label: 'Role and Current Earnings',
    eventKey: tab.role,
    icon: 'folder'
  },
  {
    label: 'Availability',
    icon: 'check-circle',
    eventKey: tab.availability
  },
  {
    label: 'Upload Resume',
    eventKey: tab.resume,
    icon: 'upload'
  }
];

export const tabFields = {
  [tab.basic]: [
    'username',
    'contactNumber',
    'country',
    'about',
    'github',
    'linkedIn'
  ],
  [tab.skill]: ['skills'],
  [tab.availability]: ['jobPreference', 'startWork'],
  [tab.education]: ['education'],
  [tab.experience]: ['yearsOfExperience'],
  [tab.resume]: [''],
  [tab.role]: ['role', 'expectedAnnualEarning', 'currentAnnualEarning']
};

export type TabValues = (typeof tab)[keyof typeof tab];

export const validateTab = (fields: string[], touchedFields: string[]) => {
  const status: Record<TabValues, boolean> = {
    [tab.basic]: false,
    [tab.skill]: false,
    [tab.availability]: false,
    [tab.education]: false,
    [tab.experience]: false,
    [tab.resume]: false,
    [tab.role]: false
  };

  fields.forEach(field => {
    for (const key in status) {
      if (Object.prototype.hasOwnProperty.call(status, key)) {
        const availableFields = tabFields[key];
        if (availableFields.includes(field) && touchedFields.includes(field)) {
          status[key] = true;
        }
      }
    }
  });

  return status;
};
